<template>
  <LoadingWrapper :state="status" v-if="canSeeData">
    <EvaluationSlide
      :feedback-topic="data.feedbackTopic"
      :scale="data.scale"
      :skill-data="data.skillData"
      :strengths="data.strengths"
      :potentials="data.potentials"
      :underestimates="data.underestimates"
      :overestimates="data.overestimates"
      :texts="data.texts"
    />
  </LoadingWrapper>

  <div v-else class="flex h-full flex-col items-center justify-center">
    <BaseEmptyVisual class="max-w-sm" />
    <p class="text-body-large lg:text-title-large">Es sind noch keine Feedbackdaten freigegeben.</p>
  </div>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useFinalEvaluationSlide } from '../composable/use-final-evaluation-slide'
  import EvaluationSlide from './EvaluationSlide.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import BaseEmptyVisual from '@/core/components/base/empty-visual/BaseEmptyVisual.vue'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)

  const { status, data, canSeeData } = useFinalEvaluationSlide(feedbackTopicId)
</script>
